import { administrationRequests } from "api/administrationApi";
import { CLASSES } from "utils/constants";
import { createExporter } from "utils/createExporter";

export const ClassesExporter = createExporter(
  `student_${CLASSES}.xlsx`,
  [
    { key: "discipline", label: "Дисциплина" },
    { key: "date", label: "Дата" },
    { key: "startTime", label: "От" },
    { key: "endTime", label: "До" },
    { key: "studyGroups", label: "Учебни групи" },
    { key: "room", label: "Зала" },
  ],
  record => ({
    ...record,
    discipline: record.discipline?.name,
    studyGroups: Array.isArray(record.studyGroups) ? record.studyGroups.map(sg => sg).join(", ") : "",
    room: `${record.room?.roomName} - ${record.room?.buildingName}`,
  }),
  [
    {
      source: "disciplineId",
      target: administrationRequests.getDisciplinesSelect(),
      name: "discipline",
    },
    {
      source: "roomId",
      target: administrationRequests.getRoomsSelect(),
      name: "room",
    },
  ],
);
